/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { QuoteTestExecutionAudit } from "./QuoteTestExecutionAudit";
import {
  QuoteTestExecutionAuditFromJSON,
  QuoteTestExecutionAuditFromJSONTyped,
  QuoteTestExecutionAuditToJSON,
  QuoteTestExecutionAuditToJSONTyped,
} from "./QuoteTestExecutionAudit";
import type { QuoteTestExecutionExpectation } from "./QuoteTestExecutionExpectation";
import {
  QuoteTestExecutionExpectationFromJSON,
  QuoteTestExecutionExpectationFromJSONTyped,
  QuoteTestExecutionExpectationToJSON,
  QuoteTestExecutionExpectationToJSONTyped,
} from "./QuoteTestExecutionExpectation";
import type { QuoteTestExecutionType } from "./QuoteTestExecutionType";
import {
  QuoteTestExecutionTypeFromJSON,
  QuoteTestExecutionTypeFromJSONTyped,
  QuoteTestExecutionTypeToJSON,
  QuoteTestExecutionTypeToJSONTyped,
} from "./QuoteTestExecutionType";
import type { QuoteTestResult } from "./QuoteTestResult";
import {
  QuoteTestResultFromJSON,
  QuoteTestResultFromJSONTyped,
  QuoteTestResultToJSON,
  QuoteTestResultToJSONTyped,
} from "./QuoteTestResult";
import type { QuoteTestExecutionState } from "./QuoteTestExecutionState";
import {
  QuoteTestExecutionStateFromJSON,
  QuoteTestExecutionStateFromJSONTyped,
  QuoteTestExecutionStateToJSON,
  QuoteTestExecutionStateToJSONTyped,
} from "./QuoteTestExecutionState";

/**
 *
 * @export
 * @interface QuoteTestExecution
 */
export interface QuoteTestExecution {
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecution
   */
  executionId?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecution
   */
  scenarioId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteTestExecution
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecution
   */
  createdBy?: string;
  /**
   *
   * @type {QuoteTestExecutionState}
   * @memberof QuoteTestExecution
   */
  state?: QuoteTestExecutionState;
  /**
   *
   * @type {QuoteTestExecutionType}
   * @memberof QuoteTestExecution
   */
  type?: QuoteTestExecutionType;
  /**
   *
   * @type {Array<QuoteTestExecutionExpectation>}
   * @memberof QuoteTestExecution
   */
  successfulExpectations?: Array<QuoteTestExecutionExpectation>;
  /**
   *
   * @type {Array<QuoteTestExecutionExpectation>}
   * @memberof QuoteTestExecution
   */
  failedExpectations?: Array<QuoteTestExecutionExpectation>;
  /**
   *
   * @type {Array<QuoteTestExecutionAudit>}
   * @memberof QuoteTestExecution
   */
  audits?: Array<QuoteTestExecutionAudit>;
  /**
   *
   * @type {Array<string>}
   * @memberof QuoteTestExecution
   */
  errors?: Array<string>;
  /**
   *
   * @type {QuoteTestResult}
   * @memberof QuoteTestExecution
   */
  quote?: QuoteTestResult;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecution
   */
  metadata?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof QuoteTestExecution
   */
  tags?: Array<string>;
}

/**
 * Check if a given object implements the QuoteTestExecution interface.
 */
export function instanceOfQuoteTestExecution(
  value: object,
): value is QuoteTestExecution {
  return true;
}

export function QuoteTestExecutionFromJSON(json: any): QuoteTestExecution {
  return QuoteTestExecutionFromJSONTyped(json, false);
}

export function QuoteTestExecutionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestExecution {
  if (json == null) {
    return json;
  }
  return {
    executionId: json["executionId"] == null ? undefined : json["executionId"],
    scenarioId: json["scenarioId"] == null ? undefined : json["scenarioId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    state:
      json["state"] == null
        ? undefined
        : QuoteTestExecutionStateFromJSON(json["state"]),
    type:
      json["type"] == null
        ? undefined
        : QuoteTestExecutionTypeFromJSON(json["type"]),
    successfulExpectations:
      json["successfulExpectations"] == null
        ? undefined
        : (json["successfulExpectations"] as Array<any>).map(
            QuoteTestExecutionExpectationFromJSON,
          ),
    failedExpectations:
      json["failedExpectations"] == null
        ? undefined
        : (json["failedExpectations"] as Array<any>).map(
            QuoteTestExecutionExpectationFromJSON,
          ),
    audits:
      json["audits"] == null
        ? undefined
        : (json["audits"] as Array<any>).map(QuoteTestExecutionAuditFromJSON),
    errors: json["errors"] == null ? undefined : json["errors"],
    quote:
      json["quote"] == null
        ? undefined
        : QuoteTestResultFromJSON(json["quote"]),
    metadata: json["metadata"] == null ? undefined : json["metadata"],
    tags: json["tags"] == null ? undefined : json["tags"],
  };
}

export function QuoteTestExecutionToJSON(json: any): QuoteTestExecution {
  return QuoteTestExecutionToJSONTyped(json, false);
}

export function QuoteTestExecutionToJSONTyped(
  value?: QuoteTestExecution | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    executionId: value["executionId"],
    scenarioId: value["scenarioId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    state: QuoteTestExecutionStateToJSON(value["state"]),
    type: QuoteTestExecutionTypeToJSON(value["type"]),
    successfulExpectations:
      value["successfulExpectations"] == null
        ? undefined
        : (value["successfulExpectations"] as Array<any>).map(
            QuoteTestExecutionExpectationToJSON,
          ),
    failedExpectations:
      value["failedExpectations"] == null
        ? undefined
        : (value["failedExpectations"] as Array<any>).map(
            QuoteTestExecutionExpectationToJSON,
          ),
    audits:
      value["audits"] == null
        ? undefined
        : (value["audits"] as Array<any>).map(QuoteTestExecutionAuditToJSON),
    errors: value["errors"],
    quote: QuoteTestResultToJSON(value["quote"]),
    metadata: value["metadata"],
    tags: value["tags"],
  };
}
